<template>
  <div class="echats">
    <div class="column">
      <div class="panel">
        <h2>文章分类统计</h2>
        <ul class="selectActive">
          <li :class="{ active: clickIndex1 == 3 }" @click="clickSelect1(3)">
            <span></span><font>当天</font>
          </li>
          <li :class="{ active: clickIndex1 == 2 }" @click="clickSelect1(2)">
            <span></span><font>近一周</font>
          </li>
          <li :class="{ active: clickIndex1 == 1 }" @click="clickSelect1(1)">
            <span></span><font>近一个月</font>
          </li>
        </ul>
        <div class="chart">
          <BarOne ref="BarOne"></BarOne>
        </div>
        <div class="footer-border"></div>
      </div>
      <div class="panel">
        <h2>近一周文章数量统计</h2>
        <div class="chart"><LineOne></LineOne></div>
        <div class="footer-border"></div>
      </div>
      <div class="panel">
        <h2>文章审核状态统计</h2>
        <div class="chart" ref="pieOne"><PieOne></PieOne></div>
        <div class="footer-border"></div>
      </div>
    </div>
    <div class="column">
      <div class="showData">
        <ul class="number">
          <li>
            <count-to
              v-if="acticleData.all"
              :start-val="0"
              :end-val="acticleData.all"
              :duration="1000"
              class="card-panel-num"
            />
          </li>
          <li>
            <count-to
              v-if="acticleData.all"
              :start-val="0"
              :end-val="acticleData.navCount"
              :duration="1000"
              class="card-panel-num"
            />
          </li>
          <li>
            <count-to
              v-if="acticleData.all"
              :start-val="0"
              :end-val="classNum"
              :duration="1000"
              class="card-panel-num"
            />
          </li>
        </ul>
        <ul class="text">
          <li>文章总数</li>
          <li>分类文章</li>
          <li>未分类文章</li>
        </ul>
      </div>
      <div class="center">
        <ul>
          <li><span>分类</span><span>数量</span></li>
          <li v-for="(item, index) in acticleData.list" :key="index">
            <span>{{ item.navName }}</span>
            <span>{{ item.count }}</span>
          </li>
        </ul>
        <div class="panel scroll">
          <h2>新增会员</h2>
          <div class="chart">
            <ShowData></ShowData>
          </div>
          <div class="footer-border"></div>
        </div>
      </div>
    </div>
    <div class="column">
      <div class="showTime">{{ nowTime }}</div>
      <div class="panel actile">
        <h2>企业所属文章数量 Top 30</h2>
        <ul class="selectActive">
          <li :class="{ active: clickIndex2 == 3 }" @click="clickSelect2(3)">
            <span></span><font>当天</font>
          </li>
          <li :class="{ active: clickIndex2 == 2 }" @click="clickSelect2(2)">
            <span></span><font>近一周</font>
          </li>
          <li :class="{ active: clickIndex2 == 1 }" @click="clickSelect2(1)">
            <span></span><font>近一个月</font>
          </li>
        </ul>
        <div class="chart">
          <BarTwo ref="BarTwo"></BarTwo>
        </div>
        <div class="footer-border"></div>
      </div>
    </div>
  </div>
</template>

<script>
import BarOne from "./echarts/BarOne.vue";
import BarTwo from "./echarts/BarTwo.vue";
import LineOne from "./echarts/lineOne.vue";
import PieOne from "./echarts/pieOne.vue";
// import MapOne from "./echarts/mapOne.vue";
import ShowData from "./echarts/showData.vue";
import { reqDocList } from "@/network/homePage";
import common from "@/common/common";
import CountTo from "vue-count-to";
export default {
  name: "homePage",
  components: { BarOne, BarTwo, LineOne, PieOne, ShowData, CountTo },
  data() {
    return {
      nowTime: "",
      acticleData: [],
      classNum: "",
      clickIndex1: 3,
      clickIndex2: 3,
    };
  },
  computed: {},
  methods: {
    getTime() {
      this.nowTime = common._timestampToTime(new Date());
      setInterval(this.getTime, 1000);
      clearInterval(this.getTime);
      this.getTime = null;
    },
    async getData() {
      let { data } = await reqDocList();
      if (data.code == 200) {
        this.acticleData = data.data;
        this.classNum = this.acticleData.all - this.acticleData.navCount;
      }
    },
    clickSelect1(val) {
      this.clickIndex1 = val;
      this.$refs.BarOne.clickSelect(val);
    },
    clickSelect2(val) {
      this.clickIndex2 = val;
      this.$refs.BarTwo.clickSelect(val);
    },
  },
  created() {
    this.getTime();
    this.getData();
  },
  beforeRouteEnter(to, from, next) {
	  // 在这里是访问不到this的，vm代表this实例
      next((vm) => {
	    vm.$store.commit("isOpened", true);
      })

 }
};
</script>

<style lang="scss" scoped>
.echats {
  position: absolute;
  width: 100%;
  padding: 10px;
  // height: 800px;
  height: 100%;
  overflow: hidden;
  display: flex;
  background: url(../../assets/img/common/f_bg.png) no-repeat;
  background-size: 100% 100%;
  .column {
    flex: 4;
    display: flex;
    flex-direction: column;
    .selectActive {
      margin-bottom: 10px;
      display: flex;
      flex-direction: row;
      justify-content: center;
      li {
        color: #ffffff;
        font-size: 12px;
        display: flex;
        align-items: center;
        span {
          width: 12px;
          height: 12px;
          border-radius: 50%;
          display: inline-block;
          background-color: #ffffff;
          margin-right: 5px;
        }
        margin: 0px 5px;
      }
      .active {
        span {
          background-color: #409eff;
        }
      }
    }
    // 图标框
    .panel {
      position: relative;
      border: 1px solid rgba(25, 186, 139, 0.17);
      flex: 1;
      padding: 5px;
      h2 {
        color: #fff;
        text-align: center;
        font-size: 16px;
        font-weight: 400;
        height: 30px;
      }
      .chart {
        width: 100%;
        height: 80%;
      }
      &::before {
        position: absolute;
        content: "";
        left: 0;
        top: 0;
        width: 15px;
        height: 10px;
        border-left: 2px solid #02a6b5;
        border-top: 2px solid #02a6b5;
      }
      &::after {
        position: absolute;
        content: "";
        right: 0;
        top: 0;
        width: 15px;
        height: 10px;
        border-right: 2px solid #02a6b5;
        border-top: 2px solid #02a6b5;
      }
      .footer-border {
        position: absolute;
        left: 0;
        bottom: 10px;
        width: 100%;
        &::before {
          position: absolute;
          content: "";
          left: 0;
          top: 0;
          width: 15px;
          height: 10px;
          border-left: 2px solid #02a6b5;
          border-bottom: 2px solid #02a6b5;
        }
        &::after {
          position: absolute;
          content: "";
          right: 0;
          top: 0;
          width: 15px;
          height: 10px;
          border-right: 2px solid #02a6b5;
          border-bottom: 2px solid #02a6b5;
        }
      }
      &:nth-child(2) {
        margin: 10px 0;
      }
    }
    // 中间列
    &:nth-child(2) {
      flex: 5;
      overflow: hidden;
      padding: 0 10px;
      // 数量展示
      .showData {
        // flex: 2;
        height: 20%;
        background: rgba(101, 132, 226, 0.1);
        padding: 10px;
        ul {
          display: flex;
          justify-content: space-around;
          align-items: center;
        }
        .number {
          flex: 1;
          height: 65%;
          border: 1px solid rgba(25, 186, 139, 0.2);
          font-size: 35px;
          color: orange;
          font-family: DS-DIGI;
          // li:nth-child(2) {
          //   border-left: 1px solid rgba(25, 186, 139, 0.2);
          //   border-right: 1px solid rgba(25, 186, 139, 0.2);
          //   padding: 0 65px;
          // }
        }
        .text {
          height: 40%;
          font-size: 16px;
          color: oldlace;
        }
      }
      // 中间部分
      .center {
        height: 80%;
        ul {
          height: 55%;
          text-align: center;
          padding: 15px 0 0;
          display: flex;
          flex-direction: column;
          li {
            flex: 1;
            display: flex;
            color: #fff;
            font-size: 14px;
            span {
              flex: 1;
            }
          }
          li:nth-child(1) {
            font-weight: 600;
            color: #61d2f7;
          }
        }
        .scroll {
          margin: 0;
          height: 45%;
          .chart {
            overflow: hidden;
          }
        }
      }
    }
    // 右侧列
    &:nth-child(3) {
      flex: 5;
      .showTime {
        font-size: 20px;
        color: rgba(255, 255, 255, 0.7);
        text-align: center;
        font-family: DS-DIGI;
        letter-spacing: 2px;
        padding: 10px 0;
      }
      .actile {
        margin: 0;
        display: flex;
        flex-direction: column;
        .chart {
          height: 100%;
        }
      }
    }
  }
  // @media screen and (max-width: 820px) {
  // }
}
</style>